import script from "./PaperFilesDialog.vue?vue&type=script&setup=true&lang=js"
export * from "./PaperFilesDialog.vue?vue&type=script&setup=true&lang=js"

import "./PaperFilesDialog.vue?vue&type=style&index=0&id=722fd95e&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-722fd95e"]])

export default __exports__